import { render, staticRenderFns } from "./NewConversationModal.vue?vue&type=template&id=0a249a63&"
import script from "./NewConversationModal.vue?vue&type=script&lang=js&"
export * from "./NewConversationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports